export const CREATE_ROLE = `
mutation createRole(
    $input: CreateRoleInput!,
  ){
    createRole(
      input: $input
    ){
      __typename
      ... on Role{
        id
        name
      }
      ... on ResultError{
        status_code
        message
      }
    }
  }
`;

export const UPDATE_ROLE = `
mutation updateRole(
    $input:  UpdateRoleInput!,
  ){
    updateRole(
      input: $input
    ){
      __typename
      ... on Role{
        id
        name
      }
      ... on ResultError{
        status_code
        message
      }
    }
  }
`;

export const DELETE_ROLE = `
mutation deleteRole(
    $id: Int!
  ){
    deleteRole(
      id: $id
    ){
          __typename
      ... on Role{
        id
        name
      }
      ... on ResultError{
        status_code
        message
      }
    }
  }
`;
